import { DataModules } from "@/store/modules/data";
import { IMenuRoute } from "@/models/routes";
import store from "@/store";
import i18n from "@/i18n";

export const PrimaryAdminRoutes: IMenuRoute[] = [
  {
    order: 1,
    label: i18n.t("_.dashboard"),
    icon: "tachometer-alt",
    to: {
      name: "adminDashboard"
    }
  },
  {
    order: 2,
    label: i18n.t("_.clients"),
    icon: "users",
    to: {
      name: "adminClients"
    },
    isActive: (currentRoute, isActive) => {
      if (currentRoute.path.startsWith("/admin/clients")) return true;
      if (currentRoute.path.startsWith("/admin/leads")) return true;
      if (currentRoute.path.startsWith("/admin/affiliates")) return true;
      return isActive;
    },
    children: [
      {
        label: i18n.t("_.clients"),
        to: {
          name: "adminClients"
        },
        isActive: (currentRoute, isActive) => {
          if (currentRoute.path.startsWith("/admin/clients/bulk-actions"))
            return false;
          return isActive;
        }
      },
      {
        label: i18n.t("_.leads"),
        to: {
          name: "adminLeads"
        }
      },
      {
        label: i18n.t("_.affiliates"),
        to: {
          name: "adminAffiliates"
        }
      },
      {
        label: i18n.t("_.bulk_actions"),
        to: {
          name: "adminClientBulkActions"
        }
      }
    ]
  },
  {
    order: 3,
    label: i18n.t("_.products_and_services"),
    icon: "box-open",
    to: {
      name: "adminProductsAndServices"
    },
    isActive: (currentRoute, isActive) => {
      if (currentRoute.path.startsWith("/admin/product-bulk-actions"))
        return true;
      return isActive;
    },
    children: [
      {
        label: i18n.t("_.subscriptions"),
        to: {
          name: "adminSubscriptionsList"
        }
      },
      {
        label: i18n.t("_.one_time_purchases"),
        to: {
          name: "adminOneTimePurchasesList"
        }
      },
      {
        label: i18n.t("_.bulk_actions"),
        to: {
          name: "adminProductBulkActions"
        }
      }
    ]
  },
  {
    order: 4,
    label: i18n.t("_.orders"),
    icon: "shopping-basket",
    to: {
      name: "adminOrders"
    },
    isActive: (currentRoute, isActive) => {
      if (currentRoute.path.startsWith("/admin/orders")) return true;
      if (currentRoute.path.startsWith("/admin/baskets")) return true;
      if (currentRoute.path.startsWith("/admin/fraudmind")) return true;
      return isActive;
    },
    children: [
      {
        label: i18n.t("_.orders"),
        to: {
          name: "adminOrders"
        }
      },
      {
        label: i18n.t("_.baskets"),
        to: {
          name: "adminBaskets"
        }
      },
      {
        label: i18n.t("_.fraudmind"),
        to: {
          name: "adminFraudmind"
        }
      }
    ]
  },
  {
    order: 5,
    label: i18n.t("_.billing"),
    icon: "receipt",
    to: {
      name: "adminBilling"
    },
    children: [
      {
        label: i18n.t("_.invoices"),
        to: {
          name: "adminInvoices"
        }
      },
      {
        label: i18n.t("_.cancellation_requests"),
        to: {
          name: "adminCancellationRequests"
        }
      },
      {
        label: i18n.t("_.credit_notes"),
        to: {
          name: "adminCreditNotes"
        }
      },
      {
        label: i18n.t("_.transactions"),
        to: {
          name: "adminTransactions"
        }
      }
    ]
  },
  {
    order: 6,
    label: i18n.t("_.support"),
    icon: "comments",
    to: {
      name: "adminSupportInbox"
    }
  },
  {
    order: 7,
    label: i18n.t("_.insights_and_reports"),
    icon: "chart-pie",
    to: {
      name: "adminInsights"
    },
    children: [
      {
        label: i18n.t("_.sales_listing"),
        to: {
          name: "salesListing"
        }
      },
      {
        label: i18n.t("_.tracked_referrals"),
        to: {
          name: "upmTrackedReferrals"
        }
      },
      {
        label: i18n.t("_.stats"),
        to: {
          name: "adminInsightsStats"
        }
      },
      {
        label: i18n.t("_.monthly_run_rate"),
        to: {
          name: "monthlyRunRate"
        }
      }
    ]
  },
  {
    order: 8,
    label: i18n.t("_.logs"),
    icon: "clipboard-list",
    to: {
      name: "adminLogs"
    },
    children: [
      {
        label: i18n.t("_.activity_log"),
        to: {
          name: "adminActivityLogs"
        }
      },
      {
        label: i18n.t("_.email_history_log"),
        to: {
          name: "adminEmailLogs"
        }
      },
      {
        label: i18n.t("_.provision_requests_log"),
        if: () =>
          store.getters[`data/${DataModules.PROVISIONING}/hasProvisioning`],
        to: () => ({
          name: "provisionRequestsLog"
        })
      }
    ]
  }
];

export const SecondaryAdminRoutes: IMenuRoute[] = [
  {
    label: i18n.t("_.settings"),
    icon: "sliders-h",
    to: {
      name: "adminSettings"
    }
  }
];
